import { Tooltip } from '@mui/material'
import styled from 'styled-components'

export interface ContainerProps {
  gap: string
  marginTop?: number | string
  marginLeft?: number | string
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: start;
  flex: 1;
  flex-direction: column;
  gap: ${({ gap }) => gap};
  ${({ marginTop }) => marginTop && `margin-top: ${marginTop};`}
  ${({ marginLeft }) => marginLeft && `margin-left: ${marginLeft};`}
  padding: 0 3px 0 3px;
  width: 100%;
  height: 48px;
`

export interface TitleProps {
  fontSize: string
  fontWeight?: number
  paddingLeft?: string
}

export const Title = styled.span<TitleProps>`
  font-size: ${({ fontSize }) => fontSize};
  ${({ fontWeight }) => fontWeight && `font-weight: ${fontWeight};`}
  line-height: 20px;
  ${({ paddingLeft }) => paddingLeft && `padding-left: ${paddingLeft};`}
`

export const TooltipTitle = styled(Tooltip)`
  cursor: pointer;
`

export interface ContainerInfoProps {
  backgroundColor?: string
}

export const ContainerInfo = styled.div<ContainerInfoProps>`
  display: flex;
  align-items: center;
  flex-direction: row;
  flex: 1;
  width: 100%;
  height: 48px;
  border: 1px solid #c7c9c7;
  box-sizing: border-box;
  border-radius: 4px;
  padding: .8rem .8rem;
  gap: .25rem;
  ${({ backgroundColor }) => backgroundColor && `background-color: ${backgroundColor};`}
`

export const Info = styled.span`
  font-size: 16px;
  line-height: 20px;
`

export const TooltipInfo = styled(Tooltip)`
  cursor: pointer;
`
